import { css } from 'styled-components';

export const baseFontSize = css`
  font-size: 16px;
  line-height: 2;
`;

export const mediumFontSize = css`
  font-size: 20px;
  line-height: 2;
`;
